import { CALL_API, REQUEST_GET } from '../middleware/api'
import { ROLE_COLLECTION } from '../schemas'

export const FETCH_ROLES_REQUEST = 'tru/roles/FETCH_ROLES_REQUEST'
export const FETCH_ROLES_SUCCEEDED = 'tru/roles/FETCH_ROLES_SUCCEEDED'
export const FETCH_ROLES_FAILED = 'tru/roles/FETCH_ROLES_FAILED'

export const fetchRoles = type => ({
  [CALL_API]: {
    types: [FETCH_ROLES_REQUEST, FETCH_ROLES_SUCCEEDED, FETCH_ROLES_FAILED],
    endpoint: `roles/${type}.json`,
    requestType: REQUEST_GET,
    schema: ROLE_COLLECTION
  }
})



// WEBPACK FOOTER //
// ../src/actions/roleActions.js